/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Company_HintInputs */

const vi_order_form_invoice_buyer_company_hint = /** @type {(inputs: Order_Form_Invoice_Buyer_Company_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập thông tin công ty theo thông tin khách cung cấp để ghi trên hóa đơn.`)
};

/**

* @param {Order_Form_Invoice_Buyer_Company_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_company_hint = /** @type {((inputs?: Order_Form_Invoice_Buyer_Company_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Company_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_company_hint(inputs)
});